import React from 'react';
import { Link } from 'react-router-dom';
import { Check, MessageCircle } from 'lucide-react';
import { COMPANY, SERVICES } from '../mock';

const Services = () => {
  return (
    <div>
      <section className="ea-hero-gradient py-16">
        <div className="mx-auto max-w-7xl px-5 text-center lg:px-8">
          <h1 className="font-display text-4xl font-extrabold text-white sm:text-5xl">Our Services</h1>
          <p className="mt-4 text-lg text-white/85">Professional home and property services across London</p>
        </div>
      </section>

      <section className="bg-white py-20">
        <div className="mx-auto max-w-6xl space-y-8 px-5 lg:px-8">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            return (
              <div
                key={s.id}
                className={`ea-card-hover grid gap-8 rounded-2xl border border-gray-100 bg-white p-8 shadow-sm md:grid-cols-12 md:items-center ${i % 2 === 1 ? '' : ''}`}
              >
                <div className="md:col-span-4">
                  <div className="flex items-center gap-4">
                    <div className="flex h-16 w-16 shrink-0 items-center justify-center rounded-2xl bg-[#e9f3ec]">
                      <Icon className="h-8 w-8 text-[#3a9b5c]" />
                    </div>
                    <h2 className="font-display text-2xl font-bold text-[#1b4f72]">{s.heading}</h2>
                  </div>
                  <p className="mt-4 text-sm leading-relaxed text-gray-600">{s.blurb}</p>
                </div>
                <div className="md:col-span-6">
                  <ul className="grid gap-3 sm:grid-cols-2">
                    {s.points.map((p) => (
                      <li key={p} className="flex items-start gap-2.5 text-sm text-gray-700">
                        <Check className="mt-0.5 h-4 w-4 shrink-0 text-[#3a9b5c]" />
                        <span>{p}</span>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="md:col-span-2">
                  <Link to="/request-a-service" className="inline-block w-full rounded-full bg-[#3a9b5c] px-5 py-3 text-center text-sm font-semibold text-white transition-colors hover:bg-[#318150]">
                    Request
                  </Link>
                </div>
              </div>
            );
          })}
        </div>
      </section>

      <section className="ea-cta-gradient py-16">
        <div className="mx-auto max-w-4xl px-5 text-center lg:px-8">
          <h2 className="font-display text-3xl font-bold text-white sm:text-4xl">Need a Service?</h2>
          <p className="mt-4 text-white/80">Tell us what you need and get a free, no-obligation assessment as soon as possible</p>
          <div className="mt-8 flex flex-wrap justify-center gap-4">
            <Link to="/request-a-service" className="rounded-full bg-[#3a9b5c] px-8 py-3.5 font-semibold text-white shadow-md transition-all hover:bg-[#46ad6a]">
              Request a Service
            </Link>
            <a href={`https://wa.me/${COMPANY.whatsapp}?text=${encodeURIComponent(COMPANY.whatsappMsg)}`} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 rounded-full border-2 border-white/60 px-8 py-3.5 font-semibold text-white transition-colors hover:bg-white/10">
              <MessageCircle size={18} /> Chat on WhatsApp
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
